import { Container, Image, Form, TextArea, Message, Select } from "semantic-ui-react"
import logo from "../../assets/logo.png"
import signature from "../../assets/signature.png"
import { useDispatch, useSelector } from "react-redux"
import { setLetterStep2DataAdditional, setLetterStep2DataBudget, setLetterStep2DataCommunication, setLetterStep2DataPartnershipCooperation, setLetterStep2DataProjectIntervention, setLetterStep2DataProjectRelevance, setLetterStep2DataWorkPlan, setLetterJsOfficer } from "../../redux/projectSlice"


const Step2DetailRejection = () => {
    const dispatch = useDispatch();
    const projectState = useSelector(state => state.project);

    const renderHeaderDestination = () => {
        const lp = projectState.leadPartner
        const contact = lp.contacts.filter(contact => contact.type === 'ContactPerson')[0]
        return (
            <div>
                <Container textAlign='left'>
                    <p>
                        {contact.title} {contact.firstName} {contact.lastName}<br />
                        {lp.nameInEnglish}<br />
                        {lp.addresses[0].houseNumber} {lp.addresses[0].street}<br />
                        {lp.addresses[0].postalCode} {lp.addresses[0].city}<br />
                        {lp.addresses[0].country}<br />
                    </p>
                </Container>
                <Container textAlign='right'>
                    <p>
                        Lille, {projectState.letter?.commission?.step2LetterDate}
                    </p>
                </Container>
            </div>
        )
    }

    const handleChangeTextArea = (e, data) => {
        if (data.className.split(' ').find(class_ => class_ === 'project-relevance')) {
            dispatch(setLetterStep2DataProjectRelevance(data.value));
        } else if (data.className.split(' ').find(class_ => class_ === 'partnership-cooperation')) {
            dispatch(setLetterStep2DataPartnershipCooperation(data.value));
        } else if (data.className.split(' ').find(class_ => class_ === 'project-intervention')) {
            dispatch(setLetterStep2DataProjectIntervention(data.value));
        } else if (data.className.split(' ').find(class_ => class_ === 'work-plan')) {
            dispatch(setLetterStep2DataWorkPlan(data.value));
        } else if (data.className.split(' ').find(class_ => class_ === 'communication')) {
            dispatch(setLetterStep2DataCommunication(data.value));
        } else if (data.className.split(' ').find(class_ => class_ === 'budget')) {
            dispatch(setLetterStep2DataBudget(data.value));
        } else if (data.className.split(' ').find(class_ => class_ === 'additional')) {
            dispatch(setLetterStep2DataAdditional(data.value));
        }
    }

    const handleSelectChange = (e, data) => {
        dispatch(setLetterJsOfficer(data.value));
    }

    const renderLetterDetails = () => {
        const letter = projectState.letter
        return (
            <Container textAlign='justified' >
                <h3>Monitoring Committee conclusions</h3>
                <div className="little-margin">
                    {/* {letter?.step2Data?.projectRelevance ? <h4>Project relevance</h4> : <h4 className="invisible-print">Project relevance</h4>} */}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print project-relevance" onChange={handleChangeTextArea} value={letter?.step2Data?.projectRelevance}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step2Data?.projectRelevance}</p>
                </div>

                <div className="prevent-page-break little-margin">
                    {letter?.step2Data?.partnershipCooperation ? <h4>Partnership and cooperation rationale</h4> : <h4 className="invisible-print">Partnership and cooperation rationale</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print partnership-cooperation" onChange={handleChangeTextArea} value={letter?.step2Data?.partnershipCooperation}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step2Data?.partnershipCooperation}</p>
                </div>

                <div className="prevent-page-break little-margin">
                    {letter?.step2Data?.projectIntervention ? <h4>Project intervention logic</h4> : <h4 className="invisible-print">Project intervention logic</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print project-intervention" onChange={handleChangeTextArea} value={letter?.step2Data?.projectIntervention}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step2Data?.projectIntervention}</p>
                </div>

                <div className="prevent-page-break little-margin">
                    {letter?.step2Data?.workPlan ? <h4>Workplan</h4> : <h4 className="invisible-print">Workplan</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print work-plan" onChange={handleChangeTextArea} value={letter?.step2Data?.workPlan}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step2Data?.workPlan}</p>
                </div>

                <div className="prevent-page-break little-margin">
                    {letter?.step2Data?.communication ? <h4>Communication</h4> : <h4 className="invisible-print">Communication</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print communication" onChange={handleChangeTextArea} value={letter?.step2Data?.communication}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step2Data?.communication}</p>
                </div>

                <div className="prevent-page-break little-margin">
                    {letter?.step2Data?.budget ? <h4>Budget</h4> : <h4 className="invisible-print">Budget</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print budget" onChange={handleChangeTextArea} value={letter?.step2Data?.budget}></TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step2Data?.budget}</p>
                </div>

                <div className="prevent-page-break little-margin">
                    {letter?.step2Data?.additional ? <h4>Other</h4> : <h4 className="invisible-print">Other</h4>}
                    <Form>
                        <TextArea className="notification-letter-text-area invisible-print additional" onChange={handleChangeTextArea} value={letter?.step2Data?.additional}>  </TextArea>
                    </Form>
                    <p className="line-break invisible-screen">{letter?.step2Data?.additional}</p>
                </div>
            </Container>
        )
    }

    const renderContactPoint = () => {
        const lp = projectState.leadPartner
        let codePays = lp.addresses.filter(address => address.type === 'Organization')[0].countryCode
        if (codePays === 'BE') {
            codePays = lp.addresses.filter(address => address.type === 'Organization')[0].nutsRegion2Code.substring(0, 3)
            console.log(codePays)
        }
        
        const contactPoints = projectState.letterContactPoints.filter(contactPoint => contactPoint.codePays === codePays)
        if (contactPoints.length === 0) {
            //Sconsole.warn('contact point not found !!');
            return(<Message negative><Message.Header>We didn't find the contact point for this area: ({codePays})</Message.Header></Message>)
        } else {
            return (
                <span>
                    {contactPoints.map(ct => (
                        <span className="text-accent">{ct.contact} ({ct.email}), </span> 
                    ))}
                    the Interreg NWE Contact Point for {contactPoints[0].pays}.
                </span>
            )
        }
    }

    const renderLetter = () => {
        const letter = projectState.letter
        const project = projectState.project
        const lp = projectState.leadPartner
        const contact = lp.contacts.filter(contact => contact.type === 'ContactPerson')[0]
        const title = project.title.filter(title => title.language === 'EN')[0].translation
        //const pays = lp.addresses.filter(address => address.type === 'Organization')[0].country
        const selectedJsOfficer = projectState.jsOfficers.filter(jsOfficer => jsOfficer.value === letter?.jsOfficer)
        console.warn(project)
        return (
            <Container textAlign='justified' className="espace-haut">
                <p>Dear {contact.title} {contact.lastName},</p>
                { project.callSettings?.endDateStep1 === null ?
                    <p>We are grateful for your efforts and the interest you have shown in our cooperation Programme by submitting a Small-Scale Project application.</p>
                    :<p>We are grateful for your efforts and the interest you have shown in our cooperation Programme by submitting a step 2 application.</p>
                }
                { project.callSettings?.endDateStep1 === null ?
                    <p>However, we regret to inform you that the Interreg NWE Monitoring Committee decided not to select your project application <span className="text-accent">{project.customIdentifier} {title} ({project.acronym})</span> for funding during its meeting on {letter?.commission?.step2Date}, in {letter?.commission?.step2Location}. </p>
                    : <p>However, we regret to inform you that the Interreg NWE Monitoring Committee decided not to select your step 2 application <span className="text-accent">{project.customIdentifier} {title} ({project.acronym})</span> for funding during its meeting on {letter?.commission?.step2Date}, in {letter?.commission?.step2Location}. </p>
                }
                <p>The Monitoring Committee conclusions are annexed to this letter and aim to provide better insight on this decision.</p>
                <p>We kindly ask you to inform your partners.</p>
                {/* <p>If you have questions and would like more information regarding this decision, please contact {renderContactPoint()}</p> */}
                <p>If you have questions and would like more information regarding this decision, please contact your responsible JS officer <Select placeholder="Select officer" defaultValue={selectedJsOfficer} options={projectState.jsOfficers} className="invisible-print" onChange={handleSelectChange} /> {!letter?.jsOfficer ? undefined : <span className="invisible-screen">{letter?.jsOfficer[0]} <span className="text-accent">({letter?.jsOfficer[1]})</span></span>}.</p>
                {/* <p>If you would like more information, please contact {renderContactPoint} the Interreg NWE Contact Point for {pays}.</p> */}
                <p>Should you have a complaint regarding this decision, you can find more information regarding the available options in Chapter 7 of the Programme Manual.</p>
                <p>Kind regards,</p>
                <Image src={signature} size='small' className="espace-haut-large" />
                <p>David Grzegorzewski</p>
                <p> Programme Director</p>
            </Container>
        )
    }

    return (

        <div className="margin-notification-letter">
            <table>
                <thead>
                    <div className="print-margin-top-15mm"></div>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <Container className="notification-letter-logo">
                                <Image src={logo} size='medium' />
                            </Container>
                            <Container textAlign="left">
                                {renderHeaderDestination()}
                            </Container>
                            {renderLetter()}
                            <div className="page-break">
                                {renderLetterDetails()}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

    )

}

export default Step2DetailRejection;